// Нормалізує boolean (зі стрічки)
export const _bool = (value) => {
    if (value === true) return true;

    if ((value === false) || 
        (value === 0) ||
        (value === '0') ||
        (value === null)) return false;
    
        if (typeof value === `string`) return (value.trim().toLowerCase() === `true`);

    return (typeof value != `undefined`);
}


// Корегує імя файлу
export const sanitizeFileName = (fileName) => {
    // Регулярний вираз для дозволених символів
    const allowedCharacters = /[^a-zA-Z0-9._\s-]/g;

    // Видаляємо всі недопустимі символи
    const sanitizedFileName = fileName.replace(allowedCharacters, '');

    // Видаляємо зайві пробіли на початку та в кінці
    return sanitizedFileName.trim();
};

// Коректно подає розмір файлів 
export const formatFileSize = (bytes) => {
    if (!bytes) return null;
    if (bytes < 1024) {
        return `${bytes} B`; // Байти
    } else if (bytes < 1024 * 1024) {
        return `${(bytes / 1024).toFixed(2)} KB`; // Кілобайти
    } else if (bytes < 1024 * 1024 * 1024) {
        return `${(bytes / (1024 * 1024)).toFixed(2)} MB`; // Мегабайти
    } else {
        return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`; // Гігабайти
    }
}



/**
 * 
 * ОПЕРАЦІЇ З КУКАМИ ТА ЛОКАЛЬНОЮ АПМЯТЮ
 */

export function _localGet(item){
    return localStorage.getItem(item)
}

export function _localSet(item, value){
    localStorage.setItem(item, value)
}
 
export function _localRem(item){
    localStorage.removeItem(item);
}

export function _sessionGet(item){
    return sessionStorage.getItem(item)
}

export function _sessionSet(item, value){
    sessionStorage.setItem(item, value)
}

export function _sessionRem(item){
    sessionStorage.removeItem(item);
}


